module.exports = __webpack_public_path__ + "static/assets/7fe1b937b85dc7fdeded6837bea60a67.png";